module.exports = __webpack_public_path__ + "img/图1-18机械零件图形.f92b3293.png";